module.exports = __webpack_public_path__ + "img/logo-lla-full-white.e5a3c759.png";